export default function GooglePlayIcon({ className = "w-5 h-5" }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			aria-hidden="true"
			focusable="false"
		>
			<path fill="#00d26a" d="M3 2.5 14.1 12 3 21.5Z" />
			<path fill="#00a7f7" d="M3 2.5 16.7 9.8 14.1 12Z" />
			<path fill="#ffca28" d="m14.1 12 2.6-2.2 3.8 2.05c.67.36.67.94 0 1.3l-3.8 2.05Z" />
			<path fill="#ff4b55" d="M3 21.5 14.1 12l2.6 3.2Z" />
		</svg>
	);
}
